<!-- 京东通用tab切换组件 -->
<template>
  <div class="new-frist-tab_all">
    <div class="tab_item" v-for="item,index in tabInfo" :key="index" @click="handleSwitch(item)" :class="{ active: tabIndex == item.value,first: index == 0, last: index == tabInfo.length-1}">
      {{ item.label }}
      <span></span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    tabInfo: {
      type: Array,
      default: () => []
    },
    isReturnObj: {
      type: Boolean,
      default: false
    },
    isDefaultIndex: {
      type: Boolean,
      default: false
    },
    defaultIndex: {
      type: [String, Number],
      default: ''
    }
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
    }),
  },
  watch: {
    defaultIndex(newVal) {
      this.tabIndex = newVal
    }
  },
  data() {
    return {
      tabIndex: 0
    }
  },
  mounted () {
    if(this.isDefaultIndex){
      this.tabIndex = this.defaultIndex;
    }else if(this.tabInfo.length){
      this.tabIndex = this.tabInfo[0].value
    }
  },
  methods: {
    handleSwitch(val){
      if(this.isReturnObj){
        this.tabIndex = val.value;
        this.$emit("switch",val)
      }else {
        this.tabIndex = val.value;
        this.$emit("switch",val.value);
      }
    }
  },
}
</script>

<style lang="scss" scoped>
</style>